var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value > 0)?_c('ui-badge',{staticClass:"orders-badge",class:_vm.classes,attrs:{"value":_vm.value}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }